import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import AnDropDown from "./AnDropDown";
import { useFloating, offset, flip, shift, autoUpdate, useDismiss, useRole, useInteractions, FloatingPortal, arrow, useClick, } from "@floating-ui/react";

//new tooltip using react portal. need to replace this from old AnToolTip
const Tooltip = ({
    containerClass="text_caption",
    innerClass="text_caption",
    textTheme='background-light-black bottom',
    tooltipPos="bottom",
    tooltTipOverlay={x: 0, y: 0},
    innerStyle,
    tooltipText, 
    children,
    showWithoutOverflowing,
    enableTooltip=true,
    showTooltip,
    ...props
    }) => {
  const [position, setPosition] = useState(null);
  const [tempPosition, setTempPosition] = useState(null);
  const containerRef = useRef(null);
  const tooltipRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    showTooltip ? handleMouseOver() : handleMouseOut()
  }, [showTooltip])
  useEffect(() => {
        const container = containerRef.current;
  
        if (container) {
          setIsOverflowing(container.scrollWidth > container.clientWidth);
        }
  }, []);

  useLayoutEffect(() => {
    if(tempPosition)
    {
        const container = containerRef.current;
        const tooltipContainer = tooltipRef.current;
        let x_cord = (tooltipContainer?.clientWidth / 2) - (container?.clientWidth / 2) + tooltTipOverlay.x;
        let y_cord = tempPosition.y + tooltTipOverlay.y;
        if(tooltipPos === 'top')
        y_cord = y_cord - tooltipContainer?.clientHeight - 7; // 7 because of the arrow in tooltip
        else if(tooltipPos === 'bottom')
        y_cord = y_cord + 7 // default bottom
        let final_xCord = tempPosition.x - x_cord
        let final_yCord = y_cord
        if(tooltipPos === 'right'){
          final_xCord = tempPosition.x + container?.clientWidth + tooltTipOverlay.x
        }
        if(tooltipPos === 'left'){
          final_xCord = tempPosition.x - tooltipContainer?.clientWidth + tooltTipOverlay.x;
          y_cord = (tooltipContainer?.clientHeight / 2) - (container?.clientHeight / 2) + tooltTipOverlay.y;
          final_yCord = tempPosition.y - y_cord
        }

        setPosition({
            x: final_xCord,
            y: final_yCord,
        })
    }
  }, [tempPosition, enableTooltip])
  
  const handleMouseOver = () => {
    const bounds = containerRef.current.getBoundingClientRect();
    let y_cord = bounds.y + bounds.height;
    if(tooltipPos !== 'bottom')
    y_cord = bounds.y
    setTempPosition({
      x: bounds.x,
      y: y_cord,
    });
  };

  const handleMouseOut = () => {setPosition(null);setTempPosition(null)};

  const anchorProps = {
    ref: containerRef,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut
  };

  const anchor = React.isValidElement(children) ? (
    React.cloneElement(children, anchorProps)
  ) : (
    <span {...anchorProps}>{children}</span>
  );

  return (
    <>
      {anchor}
      {enableTooltip && (isOverflowing || showWithoutOverflowing) && (position || tempPosition) &&
        ReactDOM.createPortal(
          <div
            ref={tooltipRef}
            className={containerClass}
            style={{
              top: position?.y || 0,
              left: position?.x || 0,
              position: "fixed",
              zIndex: 9999,
              ...props.style,
            }}
          >
            <div
              className={`tooltip-text ${textTheme} ${innerClass}`}
              style={{
                ...innerStyle,
              }}
            >
              {tooltipText()}
            </div>
          </div>,
          document.body
        )}
    </>
  );
}

export const ClickableTooltip = ({
  containerClass = "",
  innerClass = "text_caption",
  textTheme = 'background-light-black bottom',
  innerStyle,
  tooltipText,
  placement = 'bottom',
  offsetDistance = 4,
  showArrow = true,
  isOpen,
  ...props
}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  
  useEffect(() => {
    isOpen?.(showTooltip);
  }, [showTooltip])
  const arrowRef = useRef(null);
  
  const middleware = [offset(offsetDistance), flip(), shift({ })];
  if (showArrow) {
    middleware.push(arrow({ element: arrowRef }));
  }
  
  const { refs, floatingStyles, context, middlewareData, placement: actualPlacement } =
    useFloating({
      open: showTooltip,
      placement,
      middleware,
      whileElementsMounted: autoUpdate,
      strategy: "fixed",
    });

  const click = useClick(context);
  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "tooltip" });
  const arrowX = middlewareData.arrow?.x ?? 0;

  const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);
  const staticSide = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
  }[actualPlacement.split("-")[0]];

  const renderToolTip = () => {
    return (
      <AnDropDown
        containerClass={"text_caption " + containerClass}
        style={{
          position: "absolute",
          zIndex: 1,
        }}
        toggleDropDown={() => setShowTooltip(false)}
      >

          <FloatingPortal>
            <div
              className={`tooltip-text ${textTheme} ${innerClass}`}
              ref={refs.setFloating}
              style={{
                ...floatingStyles, 
                pointerEvents: 'auto',
                ...innerStyle
              }}
              {...getFloatingProps()}
            >
              {tooltipText()}
              {showArrow && (
                <div ref={arrowRef} style={{ position: "absolute", left: arrowX ?? "", width: "8px", height: "8px", background: "inherit", transform: "rotate(45deg)", pointerEvents: "none", [staticSide]: "-4px" }} />
              )}
            </div>
          </FloatingPortal>
      </AnDropDown>
    )
  }
  return (
    <div ref={refs.setReference} {...getReferenceProps()} style={{ display: "inline-block"}}>
      <div style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowTooltip(true) }}>
        {props.children}
        {showTooltip && renderToolTip()}
      </div>
    </div>
  )
}

export default Tooltip;
